import { atom } from "recoil";

const generalEquipmentItems = atom({

    key:"generalEquipmentItems",
    default: []

});

export default generalEquipmentItems;